import React from 'react';
import {useTranslation} from 'react-i18next';

function withChangeLanguage(Component: React.ElementType) {
  return () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const {i18n} = useTranslation();

    React.useEffect(() => {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 0);
    }, [i18n.language]);

    if (isLoading) return null;
    return <Component />;
  };
}

export default withChangeLanguage;
